import React from 'react'
import { ConfirmationModalBaseProps } from '../../confirmation-modal/confirmation-modal'
import { User } from '../../../api/users'
import Modal from '../../modal'
import CloseWeekForm from '../forms/close-week-form/close-week-form'
import { CreateTwoPartiesParams } from '../../../../../backend/src/services/resources/period-summaries/period-summaries.controller.service.types'

/**
 * Props for the close payroll week confirmation modal
 */
interface ClosePayrollWeekModalProps extends ConfirmationModalBaseProps {
  /** Week number to be closed */
  weekNumber: number
  /** Year of the week */
  year: number
  /** Worker name for display */
  worker: User
  /** Callback when form is submitted */
  onSubmit: (values: CreateTwoPartiesParams) => void
}

/**
 * Modal component for confirming the closure of a payroll week
 * Uses CloseWeekForm component for the form logic
 */
const ClosePayrollWeekModal: React.FC<ClosePayrollWeekModalProps> = ({
  show,
  hide,
  weekNumber,
  year,
  worker,
  onSubmit,
}) => {
  /**
   * Handle form submission
   */
  const handleSubmit = (values: CreateTwoPartiesParams) => {
    onSubmit(values)
    hide()
  }

  /**
   * Handle form cancellation
   */
  const handleCancel = () => {
    hide()
  }

  return (
    <Modal
      title={`Clôturer la semaine ${weekNumber} de ${year}`}
      actions={{ isDisplayed: show || false, setIsDisplayed: hide }}
      maxWidth={1000}
    >
      {show && (
        <CloseWeekForm
          weekNumber={weekNumber}
          year={year}
          worker={worker}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
        />
      )}
    </Modal>
  )
}

export default ClosePayrollWeekModal
